<script setup lang="ts">
import Content from '@desktop/views/Relation/Sports/components/RelationView/Content.vue'

import MainSummary from './Main/MainSummary/MainSummary.vue'
import PitchWithIncidents from './Main/PitchWithIncidents/PitchWithIncidents.vue'
import PocketIncidents from './Main/PocketIncidents/PocketIncidents.vue'
</script>

<template>
  <Content>
    <template #main>
      <MainSummary />
      <PocketIncidents />
      <PitchWithIncidents />
    </template>
  </Content>
</template>
